import Condition from './Condition';

export default Condition;
